export default {"src":"/_next/static/media/notification-active.75a16b27.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};